import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-PlaneCursor",
  "use": "icon-PlaneCursor-usage",
  "viewBox": "0 0 384.07 830.07",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384.07 830.07\" id=\"icon-PlaneCursor\"><defs></defs><g id=\"icon-PlaneCursor_图层_2\" data-name=\"图层 2\"><g id=\"icon-PlaneCursor_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M384.07,29.84V0H0V29.84H82.33A86.68,86.68,0,0,1,169,116.52V711.13a86.68,86.68,0,0,1-86.68,86.68H0v32.26h384V797.81H292.46a86.68,86.68,0,0,1-86.68-86.68V116.52a86.68,86.68,0,0,1,86.68-86.68Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol